import FaqIcon from '../../icons/faq.svg';
import PlaybookIcon from '../../icons/playbook.svg';
import MarketingIcon from '../../icons/marketing.svg';
import VideoIcon from '../../icons/howTo.svg';
import DIYIcon from '../../icons/diy.svg';
import TAGIcon from '../../icons/tag_taxonomy.svg';

export const RESOURCES = [
    {
        key: 'faq',
        asset: FaqIcon,
        text: 'FAQs',
    },
    {
        key: 'playbook_guide',
        asset: PlaybookIcon,
        text: 'Playbook/Guide',
    },
    {
        key: 'marketing_kit',
        asset: MarketingIcon,
        text: 'Marketing Kit',
    },
    {
        key: 'how_to_use',
        asset: VideoIcon,
        text: 'How to Videos',
    },
    {
        key: 'build_grabber',
        asset: DIYIcon,
        text: 'DIY Build a Smart Litter Grabber',
    },
    {
        key: 'tag_taxonomy',
        asset: TAGIcon,
        text: 'Tag Taxonomy',
    },
];

const PREFIX = 'Resources/';
export const RESOURCES_REQUESTED = `${PREFIX}RESOURCES_REQUESTED`;
export const RESOURCES_SUCCEEDED = `${PREFIX}RESOURCES_SUCCEEDED`;
export const RESOURCES_FAILED = `${PREFIX}RESOURCES_FAILED`;
